export default function Footer(){
    return(
        <div id="footer-container">
            <div id="footer-col1">
                <h3>SHOP ASTRO</h3>
                <p>Shop Collections</p>

            </div>

            <div id="footer-col2">
                <h3>ABOUT US</h3>
                <a>About Astro Athletics</a>
                <p>Blog</p>
            </div>

            <div id="footer-col3">
                <h3>HELP</h3>
                <p>Contact Us</p>

            </div>

        </div>
    )
}